export default "__VITE_ASSET__CZ1oCSqh__"